import { motion } from "framer-motion";

export default function Acknowledgement() {
    return (
        <section className="bg-[#041222] border-y border-[#12283C]" data-testid="acknowledgement-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="text-xl md:text-2xl text-slate-200 leading-relaxed max-w-4xl font-display"
                    data-testid="acknowledgement-text"
                >
                    RiverGuardian respectfully acknowledges the Wallumedegal, Burramattagal, Wangal and Gadigal
                    peoples, the Traditional Custodians of the lands and waters of the Parramatta River and
                    Sydney Harbour, and the Dharug and Eora nations. We pay our respects to Elders past and
                    present, and extend that respect to all Aboriginal and Torres Strait Islander peoples.
                </motion.p>
            </div>
        </section>
    );
}
